<script>
import ClickOutside from 'vue-click-outside';

export default {
  name: 'SelectOptions',
  directives: {
    ClickOutside,
  },
  props: {
    options: {
      type: Array,
      required: true,
    },
    firstItem: {
      type: String,
      default: null,
    },
    value: {
      type: String,
      default: '',
    },
  },
  data: function() {
    return {
      selected: this.value,
      opened: false,
      label: this.$slots.default[0].text,
    };
  },
  computed: {},
  watch: {
    selected(value) {
      this.$emit('input', value);
    },
    value(value) {
      this.selected = value;
      this.label = this.valueLabel();
    },
  },
  mounted() {
    this.popupItem = this.$el;
  },
  changed() {
    this.updateLabel();
  },
  methods: {
    click: function(event) {
      if (typeof event.target.dataset.value !== 'undefined' && event.target.dataset.value) {
        this.$emit('input', event.target.dataset.value);
      }
      this.toggle();
    },
    toggle: function() {
      this.opened = !this.opened;
      this.updateLabel();
    },
    hide: function() {
      this.opened = false;
      this.updateLabel();
    },
    updateLabel: function() {
      let label;

      if (!this.opened && (label = this.valueLabel())) {
        this.label = label;
      } else {
        this.label = this.$slots.default[0].text;
      }
    },
    valueLabel: function() {
      let label = '';
      this.options.forEach(option => {
        if (option.value === this.value) label = option.label;
      });

      return label;
    },
  },
};
</script>
<template>
  <div class="select-options__container">
    <select v-model="selected" class="cs-select">
      <!-- <option
        v-if="$slots.default"
        value=""
        disabled
      >
        <slot></slot>
      </option> -->
      <option
        v-for="option in options"
        :key="option.value"
        :value="option.value"
        :selected="option.value === value"
      >
        {{ option.label }}
      </option>
    </select>
    <ul v-click-outside="hide" :class="[{opened}]">
      <li
        v-if="$slots.default"
        data-value=""
        data-disabled="true"
        class="label"
        @click="click"
      >
        {{ label }}
        <svg width="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M12.682 4.018c.3 0 .5.1.7.3.4.4.4 1 0 1.4l-4.5 4.5 4.5 4.5c.4.4.4 1 0 1.4-.4.4-1 .4-1.4 0l-6-6 6-6c.2 0 .4-.1.7-.1" fill="#333732"/></svg>
      </li>
      <li class="select-options__container__submenu">
        <ul>
          <li
            v-for="option in options"
            :key="option.value"
            :data-value="option.value"
            :data-selected="option.value === value"
            :class="[{'selected': option.value === value}]"
            @click="click"
          >
            {{ option.label }}
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>
